import React, { useEffect, useState } from 'react';
import { Input, InputNumber } from 'formik-antd';
import FormControl from '~/components/Form/FormControl';
import InputCurrency from '~/components/Form/InputCurrency';
import { SelectAntd, SelectAntdFormik } from '~/components/Pagination/styles';
import Row from '~/components/Row';
import DateComponent from '~/components/DateComponent';
import MaskedInput from '~/components/MaskedInput';
import { useCheckAuth } from '~/components/Can/checkAuth';
import errorHandler from '~/Utils/errorHandler';
import { getStates } from '~/services/hooks/states';
import { getCities } from '~/services/hooks/cities';
import axios from 'axios';
import { message } from 'antd';

export const EventModal = ({
  t,
  event,
  loading,
  setLoading,
  customers,
  values,
  setFieldValue,
  sellers,
  errors,
  eventRevenues,
}) => {
  const authCheck = useCheckAuth();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const fetchStates = async () => {
    try {
      const data = await getStates('', 'no-paginated');

      setStates(data);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
  };

  const fetchCities = async () => {
    try {
      const data = await getCities('', 'no-paginated');

      setCities(data);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
  };

  const fetchAddress = async (cep) => {
    setLoading(true);
    try {
      const { data } = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
      const stateMatch = states?.find((s) => s?.acronym === data?.uf);
      const cityMatch = cities?.find((city) => city?.code === Number(data?.ibge));

      setFieldValue('adress_neighborhood', data?.bairro);
      setFieldValue('adress_street', data?.logradouro);
      setFieldValue('adress_number', data?.numero);

      if (stateMatch) {
        setFieldValue('state_id', stateMatch?.id);
      }

      if (cityMatch) {
        setFieldValue('city_id', cityMatch?.id);
      }
    } catch (error) {
      console.error(error);
      message.error('Não foi possível resgatar endereço pelo CEP');
    }
    setLoading(false);
  };

  const fluidPermissions = () => {
    if (eventRevenues) {
      return !eventRevenues;
    }
    if (event) {
      return authCheck('@events/edit');
    } else {
      return authCheck('@events/create');
    }
  };

  useEffect(() => {
    fetchStates();
    fetchCities();
  }, []);

  return (
    <>
      <Row>
        <FormControl
          cols={{ sm: 12, xs: 24 }}
          field="name"
          error={errors?.name}
          required
          label={t('fields:event.name')}
        >
          <Input name="name" disabled={!fluidPermissions()} />
        </FormControl>
        <FormControl
          cols={{ sm: 4, xs: 12 }}
          field="price_discount"
          error={errors?.price_discount}
          label={t('fields:event.priceDiscount')}
        >
          <InputCurrency name="price_discount" currency="R$" number disabled={!fluidPermissions()} />
        </FormControl>
        <FormControl
          cols={{ sm: 8, xs: 12 }}
          field="customer_id"
          error={errors?.customer_id}
          required
          label={t('fields:event.customer')}
        >
          <SelectAntd
            placeholder="SELECIONE"
            value={values?.customer_id ?? null}
            onSelect={(value) => {
              setFieldValue('customer_id', value);
            }}
            showSearch
            filterOption={(input, option) => option?.children?.toLowerCase()?.includes(input.toLowerCase())}
            loading={loading}
            disabled={!fluidPermissions()}
          >
            <SelectAntd.Option key="empty" value="" />
            {customers.map((item) => (
              <SelectAntd.Option key={item.id} value={item.id}>
                {item.name}
              </SelectAntd.Option>
            ))}
          </SelectAntd>
        </FormControl>
      </Row>
      <Row>
        <FormControl
          cols={{ sm: 12, xs: 12 }}
          field="description"
          error={errors?.description}
          label={t('fields:event.description')}
        >
          <Input name="description" disabled={!fluidPermissions()} />
        </FormControl>
        <FormControl
          cols={{ sm: 12, xs: 12 }}
          field="seller_id"
          error={errors?.seller_id}
          label={t('fields:event.seller')}
        >
          <SelectAntdFormik
            name="seller_id"
            placeholder="SELECIONE"
            showSearch
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            loading={loading}
            disabled={!fluidPermissions()}
          >
            {sellers?.map((item) => (
              <SelectAntdFormik.Option key={item.id} value={item.id}>
                {item.name}
              </SelectAntdFormik.Option>
            ))}
          </SelectAntdFormik>
        </FormControl>
      </Row>
      <Row>
        <FormControl
          cols={{ sm: 4, xs: 12 }}
          field="starts_at"
          error={errors?.starts_at}
          required
          label={t('fields:event.startsAt')}
        >
          <DateComponent
            value={values.starts_at}
            showTime
            onChange={(date) => {
              setFieldValue('starts_at', date);
              if (!values?.defaultDeparture) {
                setFieldValue('default_departure_at', date);
              }
            }}
            inputReadOnly={false}
            allowClear
            disabled={!fluidPermissions()}
          />
        </FormControl>
        <FormControl
          cols={{ sm: 4, xs: 12 }}
          field="ends_at"
          error={errors?.ends_at}
          required
          label={t('fields:event.endsAt')}
        >
          <DateComponent
            value={values.ends_at}
            showTime
            onChange={(date) => setFieldValue('ends_at', date)}
            disabled={!fluidPermissions()}
          />
        </FormControl>
        <FormControl
          cols={{ sm: 4, xs: 12 }}
          field="estimated_people"
          error={errors?.estimated_people}
          required
          label={t('fields:event.estimatedPeople')}
        >
          <InputNumber name="estimated_people" disabled={!fluidPermissions()} />
        </FormControl>
        <FormControl
          cols={{ sm: 6, xs: 12 }}
          field="status"
          error={errors?.status}
          required
          label={t('fields:event.status')}
        >
          <SelectAntdFormik
            placeholder="Status"
            name="status"
            onSelect={(value) => {
              setFieldValue('status', value);
            }}
            disabled={!fluidPermissions()}
          >
            <SelectAntdFormik.Option value={0}>EM PREENCHIMENTO</SelectAntdFormik.Option>
            <SelectAntdFormik.Option value={1}>ORÇAMENTO EM ANÁLISE</SelectAntdFormik.Option>
            <SelectAntdFormik.Option value={2}>APROVADO</SelectAntdFormik.Option>
            <SelectAntdFormik.Option value={3}>REPROVADO</SelectAntdFormik.Option>
            <SelectAntdFormik.Option value={4}>FINALIZADO</SelectAntdFormik.Option>
          </SelectAntdFormik>
        </FormControl>
        <FormControl
          cols={{ sm: 6, xs: 24 }}
          field="payment_status"
          error={errors?.payment_status}
          required
          label={t('fields:event.paymentStatus')}
        >
          <SelectAntd
            placeholder="Status do pagamento"
            onSelect={(value) => {
              setFieldValue('payment_status', value);
            }}
            value={values.payment_status}
            disabled={!authCheck('@superAdmin')}
          >
            <SelectAntd.Option value={0}>PAGAMENTO EM ABERTO</SelectAntd.Option>
            <SelectAntd.Option value={1}>NÃO LÍQUIDADO</SelectAntd.Option>
            <SelectAntd.Option value={2}>LÍQUIDADO</SelectAntd.Option>
          </SelectAntd>
        </FormControl>
      </Row>
      <Row>
        <FormControl
          cols={{ sm: 4, xs: 12 }}
          field="adress_cep"
          error={errors?.adress_cep}
          required
          label={t('fields:event.zipcode')}
        >
          <MaskedInput
            name="adress_cep"
            mask="99999-999"
            placeholder="_____-___"
            style={{ width: '100%' }}
            onChange={(value) => {
              if (value.length === 8) {
                fetchAddress(value);
              }
            }}
            disabled={!fluidPermissions()}
          />
        </FormControl>
        <FormControl cols={{ sm: 10, xs: 12 }} field="state_id" error={errors?.state} label={t('fields:event.state')}>
          <SelectAntdFormik
            name="state_id"
            placeholder="SELECIONE"
            showSearch
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            loading={loading}
            disabled={!fluidPermissions()}
          >
            {states?.map((item) => (
              <SelectAntd.Option key={item.id} value={item.id}>
                {item.name}
              </SelectAntd.Option>
            ))}
          </SelectAntdFormik>
        </FormControl>
        <FormControl cols={{ sm: 10, xs: 24 }} field="city_id" error={errors?.city_id} label={t('fields:event.city')}>
          <SelectAntdFormik
            key={`city-${values?.city_id}`}
            name="city_id"
            placeholder="SELECIONE"
            showSearch
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            loading={loading}
            disabled={!values?.state_id || !fluidPermissions()}
          >
            {cities
              ?.filter((c) => c?.state_id === values?.state_id)
              ?.map((item) => (
                <SelectAntd.Option key={item?.id} value={item?.id}>
                  {item?.name}
                </SelectAntd.Option>
              ))}
          </SelectAntdFormik>
        </FormControl>
      </Row>
      <Row>
        <FormControl
          cols={{ sm: 4, xs: 12 }}
          field="adress_neighborhood"
          error={errors?.adress_neighborhood}
          label={t('fields:event.neighborhood')}
        >
          <Input name="adress_neighborhood" disabled={!fluidPermissions()} />
        </FormControl>
        <FormControl
          cols={{ sm: 6, xs: 12 }}
          field="adress_street"
          error={errors?.adress_street}
          label={t('fields:event.street')}
        >
          <Input name="adress_street" disabled={!fluidPermissions()} />
        </FormControl>
        <FormControl
          cols={{ sm: 3, xs: 12 }}
          field="adress_number"
          error={errors?.adress_number}
          label={t('fields:event.addressNumber')}
        >
          <Input name="adress_number" disabled={!fluidPermissions()} />
        </FormControl>
        <FormControl
          cols={{ sm: 5, xs: 12 }}
          field="adress_reference"
          error={errors?.adress_reference}
          label={t('fields:event.addressReference')}
        >
          <Input name="adress_reference" disabled={!fluidPermissions()} />
        </FormControl>
        <FormControl
          cols={{ sm: 6, xs: 12 }}
          field="adress_local_name"
          error={errors?.adress_local_name}
          label={t('Nome do local')}
        >
          <Input name="adress_local_name" disabled={!fluidPermissions()} />
        </FormControl>
      </Row>
    </>
  );
};
